import { render, staticRenderFns } from "./rongzijianzhan.vue?vue&type=template&id=25c23bf1&scoped=true&"
import script from "./rongzijianzhan.vue?vue&type=script&lang=js&"
export * from "./rongzijianzhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c23bf1",
  null
  
)

component.options.__file = "rongzijianzhan.vue"
export default component.exports